module.exports = __webpack_public_path__ + "img/netframwork472.c60b3139.png";